module.exports = __webpack_public_path__ + "static/media/market_research_compensation.95dc8fba.png";